import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import { useLanguage } from "context/LanguageContext";
import bgImage from "assets/images/bg-coworking.jpeg";

function Information() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" py={10}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={7}
          flexDirection="column"
          sx={{ mb: 6, mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2" mb={1}>
            {messages.constructionPage.services.title}
          </MKTypography>
          <MKTypography variant="body1" color="text">
            {messages.constructionPage.services.description}
          </MKTypography>
        </Grid>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={7}>
            <Grid container spacing={3}>
              {messages.constructionPage.services.cards.map((card) => (
                <Grid item xs={12} md={6} key={card.title}>
                  <MKBox mb={{ xs: 1, md: 3 }}>
                    <DefaultInfoCard
                      icon={card.icon}
                      title={card.title}
                      description={card.description}
                    />
                  </MKBox>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title={messages.constructionPage.services.featuredTitle}
              description={messages.constructionPage.services.featuredDescription}
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: messages.constructionPage.services.featuredAction,
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
